module.exports = __webpack_public_path__ + "img/popup-game-sucai.fa3425e7.png";